<p-contextmenu #dirMenu [model]="directoryMenuItems"></p-contextmenu>

<div
    class="relative transition-all duration-500 ease-in-out p-4 rounded-2xl"
    [ngClass]="{
        'bg-blue-50/40 dark:bg-blue-900/10 ring-2 ring-blue-400 ring-inset mb-6': isDragging
    }"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
>
    <!-- DROPZONE -->
    <div
        *ngIf="isDragging"
        class="absolute inset-0 z-[60] flex flex-col items-center justify-center bg-blue-500/5 backdrop-blur-[4px] border-2 border-dashed border-blue-500/50 rounded-2xl pointer-events-none animate-in fade-in duration-300"
    >
        <div class="bg-white dark:bg-surface-800 p-8 rounded-full shadow-2xl mb-4 transform scale-110">
            <i class="pi pi-cloud-upload text-5xl text-blue-500 animate-bounce"></i>
        </div>

        <div class="text-center px-4">
            <h3 class="text-xl font-bold text-blue-600 dark:text-blue-300 mb-1">
                Solte seus arquivos aqui
            </h3>

            <p class="text-blue-500/80 dark:text-blue-400/80 text-sm font-medium">
                Enviar para:
                <span class="underline">
                    {{ currentDirectory?.name || 'Raiz' }}
                </span>
            </p>
        </div>
    </div>

    <div
        class="transition-all duration-500 ease-in-out pointer-events-none"
        [style.height]="isDragging ? '250px' : '0px'"
        [style.opacity]="isDragging ? '1' : '0'"
    ></div>

    <div class="flex-grow">

        <!-- GRID (REFATORADO / SLIM) -->
        <div
            *ngIf="directories.length > 0 && viewMode === ViewMode.GRID"
            class="grid mt-2 gap-3 grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 2xl:grid-cols-12"
        >
            <div
                *ngFor="let directory of directories"
                class="group relative flex flex-col items-center justify-center
                       Bopx-2 py-2 rounded-xl cursor-pointer text-center
                       border border-transparent
                       hover:border-surface-200 dark:hover:border-surface-700
                       hover:bg-white dark:hover:bg-surface-800
                       hover:shadow-sm
                       transition-all duration-200"
                (click)="selectDirectory(directory)"
                (contextmenu)="onDirectoryContextMenu($event, directory, dirMenu)"
                [pTooltip]="directory.shareable ? directory.alias : directory.name"
                tooltipPosition="bottom"
            >
                <!-- share -->
                <i
                    *ngIf="directory.shareable"
                    class="pi pi-share-alt absolute top-1.5 right-1.5 text-[8px] text-blue-500 opacity-80"
                >
                </i>

                <!-- icon -->
                <div
                    class="flex items-center justify-center
                           w-10 h-10 rounded-lg
                           bg-amber-50 dark:bg-amber-900/20
                           mb-1.5
                           group-hover:scale-105
                           transition-transform"
                >
                    <i
                        class="material-icons text-[24px] text-amber-500"
                    >
                        folder
                    </i>
                </div>

                <!-- name -->
                <div
                    class="w-full truncate px-1
                           text-[11px] font-semibold
                           text-surface-900 dark:text-surface-0
                           leading-tight"
                >
                    {{ directory.shareable ? directory.alias : directory.name }}
                </div>

                <!-- type -->
                <div
                    class="mt-0.5
                           text-[9px] font-bold uppercase tracking-wide
                           text-surface-400 dark:text-surface-500"
                >
                    {{ directory.shareable ? 'Compartilhado' : 'Pasta' }}
                </div>
            </div>
        </div>

        <!-- LIST -->
        <div
            *ngIf="directories.length > 0 && viewMode === ViewMode.LIST"
            class="bg-white dark:bg-surface-900 rounded-xl overflow-hidden shadow-sm"
        >
            <div
                *ngFor="let directory of directories"
                class="group p-4 hover:bg-surface-50 dark:hover:bg-surface-800/50 cursor-pointer flex items-center gap-4 transition-all duration-200 last:border-0 border-b border-surface-100 dark:border-surface-800"
                (click)="selectDirectory(directory)"
                (contextmenu)="onDirectoryContextMenu($event, directory, dirMenu)"
            >
                <div
                    class="flex items-center justify-center w-10 h-10 rounded-lg bg-amber-50 dark:bg-amber-900/20 text-amber-500 group-hover:scale-110 transition-transform"
                >
                    <i class="material-icons text-2xl">folder</i>
                </div>

                <div class="flex-grow min-w-0">
                    <div
                        class="text-surface-900 dark:text-surface-0 text-sm font-semibold truncate mb-0.5"
                    >
                        {{ directory.shareable ? directory.alias : directory.name }}
                    </div>

                    <div
                        class="flex items-center gap-1.5 text-[11px] text-surface-400 dark:text-surface-500"
                    >
                        <i class="pi pi-map-marker text-[10px]"></i>

                        <span class="truncate">
                            {{ getParentName(directory?.parentId ?? null) }}
                        </span>
                    </div>
                </div>

                <div class="hidden sm:flex items-center">
                    <div class="inline-flex items-center gap-3 p-0.5 select-none leading-none">

                        <div
                            [ngClass]="{
                                'bg-indigo-500/10 text-indigo-400 border-indigo-500/20': directory.shareable,
                                'bg-blue-500/10 text-blue-400 border-blue-500/20': !directory.shareable && directory.hasChildren === true,
                                'bg-surface-200/50 text-surface-500 border-surface-300 dark:bg-surface-800/50': !directory.shareable && directory.hasChildren === false,
                                'bg-emerald-500/10 text-emerald-400 border-emerald-500/20': !directory.shareable && directory.hasChildren === undefined
                            }"
                            class="flex items-center gap-2 px-2.5 py-1 rounded-md border text-[10px] font-bold uppercase tracking-wider"
                        >
                            <span
                                class="h-1.5 w-1.5 rounded-full"
                                [ngClass]="{
                                    'bg-indigo-400': directory.shareable,
                                    'bg-blue-400': !directory.shareable && directory.hasChildren === true,
                                    'bg-surface-400': !directory.shareable && directory.hasChildren === false,
                                    'bg-emerald-400': !directory.shareable && directory.hasChildren === undefined
                                }"
                            ></span>

                            {{ directory.shareable ? 'Compartilhado' : directory.hasChildren ? 'Possui arquivos ou diretórios' : 'Diretório final' }}
                        </div>

                        <div
                            *ngIf="directory.shareable && (directory.sharedGroup?.length ?? 0) > 0"
                            class="h-4 w-px bg-surface-300 dark:bg-surface-700"
                        ></div>

                        <div
                            *ngIf="directory.shareable && (directory.sharedGroup?.length ?? 0) > 0"
                            class="flex items-center gap-2 min-w-0"
                        >
                            <div class="flex items-center -space-x-2">

                                <ng-container *ngFor="let user of directory.sharedGroup?.slice(0, 4)">
                                    <div
                                        class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-surface-200 text-[11px] font-semibold text-surface-700 shadow-sm transition-all hover:z-10 hover:scale-110 dark:border-surface-900 dark:bg-surface-700 dark:text-surface-200"
                                        [pTooltip]="user?.name"
                                        tooltipPosition="top"
                                    >
                                        {{ getInitials(user?.name) }}
                                    </div>
                                </ng-container>

                                <div
                                    *ngIf="(directory.sharedGroup?.length ?? 0) > 4"
                                    class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-surface-300 text-[10px] font-bold text-surface-700 dark:border-surface-900 dark:bg-surface-600 dark:text-white"
                                    [pTooltip]="getFullSharedNames(directory)"
                                >
                                    +{{ (directory.sharedGroup?.length ?? 0) - 4 }}
                                </div>
                            </div>
                        </div>

                        <div class="flex items-center pl-3">
                            <i
                                class="pi pi-chevron-right text-surface-400 text-sm transition-all duration-200 group-hover:translate-x-1 group-hover:text-primary-500"
                            ></i>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- EMPTY -->
        <div
            *ngIf="directories.length === 0 && !isDragging"
            class="flex flex-col items-center justify-center py-12 text-surface-400"
        >
            <div class="bg-surface-100 dark:bg-surface-800 p-6 rounded-full mb-4">
                <i class="material-icons text-5xl">folder_open</i>
            </div>

            <p class="text-lg font-medium text-surface-500">
                Nenhum diretório encontrado
            </p>
        </div>

    </div>
</div>